import React from 'react';

const RuleFilters = ({
  customers,
  rulesetTypes,
  selectedCustomerId,
  selectedRulesetTypeId,
  selectedRuleType,
  searchTerm,
  onCustomerChange,
  onRulesetTypeChange,
  onRuleTypeChange,
  onSearchChange,
  loading,
  hideCustomerFilter = false,
}) => {
  const ruleTypes = [
    { value: '', label: 'All Rule Types' },
    { value: 'STRING_MANIPULATION', label: 'String Manipulation' },
    { value: 'CONDITIONAL', label: 'Conditional Logic' },
    { value: 'LOOKUP', label: 'Reference Data Lookup' }
  ];

  return (
    <div className="mb-3" style={{ 
      display: 'grid', 
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
      gap: '15px',
      padding: '15px',
      backgroundColor: '#f8f9fa',
      borderRadius: '4px'
    }}>
      {!hideCustomerFilter && (
        <div>
          <label htmlFor="customerFilter" className="form-label">Customer</label>
          <select
            id="customerFilter"
            className="form-select"
            value={selectedCustomerId}
            onChange={(e) => onCustomerChange(e.target.value)}
            disabled={loading && customers.length === 0}
          >
            <option value="">Select Customer</option>
            {Array.isArray(customers) && customers.map(customer => (
              <option key={customer.id} value={customer.id}>
                {customer.customerName}
              </option>
            ))}
          </select>
        </div>
      )}

      <div>
        <label htmlFor="rulesetTypeFilter" className="form-label">Ruleset Type</label>
        <select
          id="rulesetTypeFilter"
          className="form-select"
          value={selectedRulesetTypeId}
          onChange={(e) => onRulesetTypeChange(e.target.value)}
          disabled={!selectedCustomerId}
        >
          <option value="">All Ruleset Types</option>
          {Array.isArray(rulesetTypes) && rulesetTypes.map(type => (
            <option key={type.id} value={type.id}>
              {type.name}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label htmlFor="ruleTypeFilter" className="form-label">Rule Type</label>
        <select
          id="ruleTypeFilter"
          className="form-select"
          value={selectedRuleType}
          onChange={(e) => onRuleTypeChange(e.target.value)}
          disabled={!selectedCustomerId}
        >
          {ruleTypes.map(type => (
            <option key={type.value} value={type.value}>
              {type.label}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label htmlFor="searchFilter" className="form-label">Search by Name</label>
        <input
          id="searchFilter"
          type="text"
          className="form-control"
          placeholder="Search rules..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          disabled={!selectedCustomerId}
        />
      </div>
    </div>
  );
};

export default RuleFilters;
